import { ErrorContent } from "./ErrorContent";

const ForbiddenDescription = () => (
  <>
    この校舎の入退室受付を利用する権限がありません。アクセス権限の設定（操作者の所属・IPアドレス制限）をご確認のうえ、システム担当者にお問い合わせください。
    <p>403 Forbidden.</p>
  </>
);

export const ForbiddenErrorView = () => (
  <ErrorContent
    title="アクセス権限がありません。"
    description={<ForbiddenDescription />}
  />
);
